export enum LineItemSourceType {
  Custom = 'CUSTOM',
  FromInvoice = 'FROM_INVOICE',
}
